import React from 'react';
import Footer from './Footer.component';

const About = () => {
  return (
    <React.Fragment>
      <div id='main'>
        <section className='tiles'>
          <article id='about-card'>
            <span className='image'>
              <img src='complimentary-card.jpg' alt='complimentary-card' title='complimentary-card' />
            </span>
          </article>
        </section>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default About;
